// Need to use the React-specific entry point to import createApi
import { baseApi } from "./baseApi";
import { getToken } from "./localStorageService";

// using CSRF token from Local Storage

// Define a service using a base URL and expected endpoints
export const questionApi = baseApi.injectEndpoints({
  credentials: "include",
  endpoints: (builder) => ({
    addQuestion: builder.mutation({
      query: (data) => {
        return {
          url: "questions",
          method: "POST",
          body: data,
          headers: {
            // "Content-type": "application/json; charset=UTF-8",
          },
        };
      },
      // invalidatesTags: ['User'],
    }),
    updateQuestion: builder.mutation({
      query: ({ data, id }) => {
        return {
          url: `questions/${id}`,
          method: "PATCH",
          body: data,
          headers: {
            // "Content-type": "application/json; charset=UTF-8",
          },
        };
      },
      // invalidatesTags: ['User'],
    }),
    deleteQuestion: builder.mutation({
      query: (id) => {
        return {
          url: `questions/${id}`,
          method: "DELETE",
          // body: user,
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        };
      },
      // invalidatesTags: ['User'],
    }),
    getAllQuestion: builder.query({
      query: (query) => {
        let queryString = new URLSearchParams(query).toString();
        return {
          url: `questions?${queryString}`, // todo:
          method: "GET",
          // headers: {
          //   "Content-type": "application/json; charset=UTF-8",
          // },
        };
      },
      keepUnusedDataFor: 0,
      refetchOnFocus: true,
      // providesTags: ['User'],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useAddQuestionMutation,
  useUpdateQuestionMutation,
  useDeleteQuestionMutation,
  useGetAllQuestionQuery,
} = questionApi;
